import {t} from 'i18next';
import {Language} from '../lib/enums';
import {CSSProperties} from 'react';
import {UaRadioButton} from 'uppsala.ui.react';

interface CeremonyLanguageProps {
  selectedLanguage: string;
  style?: CSSProperties;
  onInputChange: (value: string) => void;
}

export const CeremonyLanguage = (props: CeremonyLanguageProps) => {
  return (
    <fieldset style={props.style}>
      <legend>{t('booking.ceremonyLanguage')}</legend>
      <UaRadioButton
        id={'swedishCeremony'}
        value={Language.Swedish}
        name={'ceremonyLanguage'}
        selected={props.selectedLanguage === Language.Swedish}
        onChange={props.onInputChange}
        label={t('languages.swedish') ?? ''}
      />
      <div style={{marginBottom: '15px'}} />
      <UaRadioButton
        id={'englishCeremony'}
        value={Language.English}
        name={'ceremonyLanguage'}
        selected={props.selectedLanguage === Language.English}
        onChange={props.onInputChange}
        label={t('languages.english') ?? ''}
      />
    </fieldset>
  );
};
